import { render, staticRenderFns } from "./FooterTop.vue?vue&type=template&id=216c61bb&"
import script from "./FooterTop.vue?vue&type=script&lang=ts&"
export * from "./FooterTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports